import { render, staticRenderFns } from "./_TaskResponsible.vue?vue&type=template&id=720711f4&scoped=true&"
import script from "./_TaskResponsible.vue?vue&type=script&lang=js&"
export * from "./_TaskResponsible.vue?vue&type=script&lang=js&"
import style0 from "./_TaskResponsible.vue?vue&type=style&index=0&id=720711f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720711f4",
  null
  
)

export default component.exports